var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBlockCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 74C53.5163 74 66.5 61.0163 66.5 45C66.5 28.9837 53.5163 16 37.5 16C21.4837 16 8.5 28.9837 8.5 45C8.5 61.0163 21.4837 74 37.5 74Z",
    stroke: "#364052",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 15,
    width: 61,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 75C54.0685 75 67.5 61.5685 67.5 45C67.5 28.4315 54.0685 15 37.5 15C20.9315 15 7.5 28.4315 7.5 45C7.5 61.5685 20.9315 75 37.5 75Z",
    fill: "#364052"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51953 55.418H68.2275V76.268H6.57853L6.51953 55.418Z",
    fill: "#364052"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.782 16.569L38 13L35.218 16.569C32.928 19.507 32.928 23.496 35.218 26.434L38 30L40.782 26.431C43.072 23.496 43.072 19.507 40.782 16.569ZM42.51 42.978C41.2637 43.5938 40.2141 44.5455 39.4794 45.7257C38.7448 46.9059 38.3543 48.2678 38.352 49.658C38.3512 49.8833 38.261 50.099 38.1013 50.2578C37.9415 50.4166 37.7253 50.5055 37.5 50.505C37.2749 50.5055 37.0588 50.4168 36.8991 50.2582C36.7394 50.0996 36.6491 49.8841 36.648 49.659C36.6456 48.2688 36.2552 46.9069 35.5208 45.7266C34.7864 44.5463 33.7371 43.5943 32.491 42.978L26.5 40.002V42.946C26.5024 44.3362 26.8928 45.6981 27.6272 46.8784C28.3616 48.0587 29.4109 49.0107 30.657 49.627L36.346 52.451V61.659C36.346 62.424 36.863 61.659 37.5 61.659C38.138 61.659 38.654 62.426 38.654 61.659V52.449L44.343 49.625C45.5894 49.0089 46.639 48.0569 47.3735 46.8763C48.108 45.6957 48.4981 44.3334 48.5 42.943V40L42.51 42.978Z",
    fill: "#364052"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 24H38.5V67H36.5V24Z",
    fill: "#364052"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 42L44.994 38.93C47.755 37.624 49.5 34.958 49.5 32.037V29L43.006 32.07C40.245 33.376 38.5 36.042 38.5 38.963V42ZM37.5 42L31.006 38.93C28.245 37.624 26.5 34.958 26.5 32.037V29L32.994 32.07C35.755 33.376 37.5 36.042 37.5 38.963V42ZM38.5 64L44.994 60.93C47.755 59.624 49.5 56.958 49.5 54.037V51L43.006 54.07C40.245 55.376 38.5 58.042 38.5 60.963V64ZM37.5 64L31.006 60.93C28.245 59.624 26.5 56.958 26.5 54.037V51L32.994 54.07C35.755 55.376 37.5 58.042 37.5 60.963V64ZM38.5 32L44.994 28.93C47.755 27.624 49.5 24.958 49.5 22.037V19L43.006 22.07C40.245 23.376 38.5 26.042 38.5 28.963V32ZM37.5 32L31.006 28.93C28.245 27.624 26.5 24.958 26.5 22.037V19L32.994 22.07C35.755 23.376 37.5 26.042 37.5 28.963V32Z",
    fill: "#364052"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlockCrop);
export default __webpack_public_path__ + "static/media/ic-block-crop.20cecaa95e07248be3d4596428654a53.svg";
export { ForwardRef as ReactComponent };